<template>
  <v-sheet height="100%" width="100%" color="transparent">
    <v-sheet
      v-if="loading"
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>

    <v-sheet>
      <Title>Detalhes do imóvel</Title>

      <v-container
        class="pt-8 pt-md-12 pb-12 pb-lg-16 px-2 px-md-3 px-lg-4 property"
      >
        <div
          class="align-center d-flex justify-space-between"
          v-if="item.title || price"
        >
          <span
            class="
              primary--text
              text-h5 text-sm-h4 text-md-h3 text-lg-h2
              font-weight-bold
            "
            v-if="item.title"
          >
            {{ item.title }}
          </span>

          <span
            class="
              accent--text
              text-h5 text-sm-h4 text-md-h3 text-lg-h2
              font-weight-bold
              pl-4
            "
            v-if="price && xs"
          >
            {{ price }}
          </span>
        </div>

        <div
          class="d-flex align-center justify-space-between"
          v-if="item.ref || item.district"
        >
          <span
            class="
              primary--text
              text-body-1 text-sm-h6 text-md-h5 text-lg-h4
              font-weight-regular
            "
            v-if="item.ref"
          >
            REF: {{ item.ref }}
          </span>
          <span
            class="
              primary--text
              text-body-1 text-sm-h6 text-md-h5 text-lg-h4
              font-weight-regular
              pl-4
            "
            v-if="item.district && xs"
          >
            {{ item.district }}
          </span>
        </div>

        <v-row class="mx-n2 mx-md-n3 mx-lg-n4">
          <v-col class="pt-8 pt-md-12 px-2 px-md-3 px-lg-4" cols="12" sm="6">
            <v-sheet color="#F5F7FA" class="rounded-lg property-images">
              <LightGallery
                :images="item.img.list"
                :index="index"
                @close="index = null"
                v-if="item.img && item.img.list.length"
              />

              <img
                class="d-block rounded-lg property-images-featured"
                :src="imageFeatured + `?resize=1&w=600`"
                @click="index = indexFeatured"
                v-if="imageFeatured"
              />

              <div
                class="py-3 px-1 px-sm-2 px-md-3"
                v-if="item.img && item.img.list.length"
              >
                <carousel
                  responsiveBaseElement="body"
                  class="rounded-lg property-carousel-images"
                  :dots="false"
                  nav
                  :responsive="settingsCarouselImages"
                >
                  <div
                    class="item"
                    v-for="(img, key) in item.img.list"
                    :key="key"
                  >
                    <img
                      class="d-block rounded-lg property-carousel-images-item"
                      @click="
                        imageFeatured = img;
                        indexFeatured = key;
                      "
                      :src="img + `?resize=1&w=300`"
                    />
                  </div>
                </carousel>
              </div>
            </v-sheet>

            <div v-if="details.length && xs" class="pt-4">
              <div
                class="d-inline-flex align-center mr-3 mr-lg-4"
                v-for="({ text, icon }, key) in details"
                :key="key"
              >
                <v-icon size="20" color="secondary"> {{ icon }} </v-icon>
                <span class="ml-2">
                  {{ text }}
                </span>
              </div>
            </div>

            <v-btn
              small
              :to="`${path}?tipo=${item.type.id}`"
              color="primary"
              class="white--text mt-2"
              v-if="item.type && item.type.title && xs"
              height="22px"
              depressed
              rounded
            >
              {{ item.type.title }}
            </v-btn>

            <div class="pt-4 pt-sm-8 pt-md-12" v-if="item.text">
              <div
                class="
                  primary--text
                  text-h6 text-sm-h5 text-lg-4
                  font-weight-bold
                "
              >
                Descrição
              </div>

              <div
                class="
                  primary--text
                  text--lighten-1 text-body-1 text-md-h6
                  font-weight-regular
                  mt-3
                  property-text
                "
                v-html="item.text"
              ></div>
            </div>
          </v-col>

          <v-col class="pt-sm-8 pt-md-12 px-2 px-md-3 px-lg-4" cols="12" sm="6">
            <div
              class="
                accent--text
                text-h4 text-sm-h3 text-lg-h2
                font-weight-bold
              "
              v-if="price && !xs"
            >
              <big>
                {{ price }}
              </big>
            </div>

            <div
              class="
                primary--text
                text-body-1 text-sm-h6 text-md-h5 text-lg-h4
                font-weight-regular
              "
              v-if="item.district && !xs"
            >
              {{ item.district }}
            </div>

            <div v-if="details.length && !xs" class="mt-2">
              <div
                class="d-inline-flex align-center mr-3 mr-lg-4"
                v-for="({ text, icon }, key) in details"
                :key="key"
              >
                <v-icon size="20" color="secondary"> {{ icon }} </v-icon>
                <span class="ml-2">
                  {{ text }}
                </span>
              </div>
            </div>

            <v-btn
              :to="`${path}?tipo=${item.type.id}`"
              color="primary"
              class="white--text mt-3"
              v-if="item.type && item.type.title && !xs"
              height="30px"
              depressed
              rounded
            >
              {{ item.type.title }}
            </v-btn>

            <v-divider
              v-if="price || item.district || details.length || xs"
              class="my-4 my-md-5 my-lg-6"
            />

            <div
              class="
                primary--text
                text-h4 text-sm-h3 text-lg-h2
                font-weight-bold
                text-center
              "
            >
              Dúvidas sobre o imóvel?
            </div>

            <div
              class="
                primary--text
                text-h6
                font-weight-regular
                text-center
                mt-1
                px-lg-4
              "
            >
              Entre em contato com a gente no WhatsApp para mais informações.
            </div>

            <v-btn
              color="primary darken-1"
              class="mt-4 mt-md-6 mt-lg-8"
              width="100%"
              :height="xs ? `40px` : `55px`"
              :href="whatsapp"
              rounded
              target="_blank"
              depressed
              v-if="whatsapp"
            >
              <v-icon color="white" size="xs ? `18px` : `30px`">
                fa-whatsapp
              </v-icon>
              <span
                class="
                  white--text
                  text-h6 text-md-h5 text-lg-h4
                  font-weight-bold
                  text-none
                  ml-2
                "
                >Enviar mensagem</span
              >
            </v-btn>

            <v-divider
              v-if="(map.lat && map.lon) || item.address"
              class="my-4 my-md-5 my-lg-6"
            />

            <v-sheet
              color="#F5F7FA"
              class="rounded-lg property-map"
              v-if="map.lat && map.lon"
            >
              <iframe
                class="d-block rounded-lg"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                :src="`https://maps.google.com/maps?q=${map.lat},${map.lon}&hl=pt-br&z=14&output=embed`"
              ></iframe>

              <div
                class="
                  primary--text
                  text--darken-1 text-body-1
                  font-weight-medium
                  text-center
                  py-3
                "
                v-if="item.address"
              >
                {{ item.address }}
              </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-sheet>
</template>

<script>
import Title from "../../widgets/Title.vue";
import { LightGallery } from "vue-light-gallery";
import carousel from "vue-owl-carousel2";
import { formatPrice } from "../../../utils/formatPrice";

const _config = {
  path: `/imoveis`,
  mod: `properties`,
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    index: null,
    item: [],
    details: [],
    indexFeatured: null,
    imageFeatured: null,
    map: {
      lat: null,
      lon: null,
    },
    settingsCarouselImages: {
      0: {
        items: 3,
        margin: 4,
      },
      500: {
        items: 4,
        margin: 8,
      },
      600: {
        items: 3,
        margin: 8,
      },
      960: {
        items: 4,
        margin: 12,
      },
    },
  }),
  computed: {
    whatsapp() {
      if (
        !this.$rest(`informations`).item ||
        !this.$rest(`informations`).item.whatsapp
      )
        return "";

      return this.$rest(`informations`).item.whatsapp;
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    price() {
      if ((!this.item && this.item.price === null) || !this.item.price)
        return "";

      return formatPrice(this.item.price);
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;

          if (this.$rest(_config.mod).item.img.list.length) {
            const images = [];

            this.$rest(_config.mod).item.img.list.map(({ path }, i) => {
              if (path === this.item.img.featured) {
                this.indexFeatured = i;
              }

              images.push(
                this.files + path + "?resize=1&w=" + (this.xs ? 600 : 1920)
              );
            });

            this.$rest(_config.mod).item.img.list = images;
          }

          if (this.item.img && this.item.img.featured)
            this.imageFeatured = this.files + this.item.img.featured;

          if (this.item.map && this.item.map.split(",").length === 2) {
            const map = this.item.map.split(",");

            this.map.lat = map[0].trim();
            this.map.lon = map[1].trim();
          }

          this.details = [];
          if (this.item.garage)
            this.details.push({
              icon: "fas fa-car",
              text:
                this.item.garage + (this.item.garage > 1 ? ` Vagas` : ` Vaga`),
            });

          if (this.item.bedrooms)
            this.details.push({
              icon: "fas fa-bed",
              text:
                this.item.bedrooms +
                (this.item.bedrooms > 1 ? ` Quartos` : ` Quarto`),
            });

          this.loading = false;
        });
    },
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    Title,
    LightGallery,
    carousel,
  },
};
</script>

<style lang="scss" scoped>
.property {
  .property-images {
    .property-images-featured,
    .property-carousel-images-item {
      aspect-ratio: 16 / 10;
      cursor: pointer;
      object-fit: cover;
      -o-object-fit: cover;
      transition: all 0.1s linear;
      width: 100%;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  .property-map {
    iframe {
      aspect-ratio: 16 / 10;
      box-shadow: 0px 4px 8px rgba(133, 136, 140, 0.12);
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
.property {
  .property-images {
    .property-carousel-images {
      .owl-nav {
        display: flex;
        height: 0;
        justify-content: space-between;
        left: -12px;
        margin-top: -18px !important;
        position: absolute;
        right: -12px;
        top: 50%;
        .owl-next,
        .owl-prev {
          background-color: #ffffff !important;
          box-shadow: 0px 2px 4px rgba(57, 60, 64, 0.15) !important;
          border-radius: 25rem !important;
          font-size: 0 !important;
          height: 36px;
          margin: 0 !important;
          padding: 0 !important;
          position: relative;
          text-indent: 200vw;
          transition: all 0.1s linear;
          white-space: nowrap;
          width: 36px;
          &:before {
            align-items: center;
            color: var(--v-primary-base) !important;
            display: flex;
            font-family: "Font Awesome 5 Free";
            font-size: 18px;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-style: normal;
            font-variant: normal;
            font-weight: 700;
            height: 100%;
            justify-content: center;
            line-height: 1;
            position: absolute;
            text-indent: 0;
            text-rendering: auto;
            top: 0;
            transition: all 0.1s linear;
            width: 100%;
          }
        }
        .owl-prev {
          &:before {
            content: "\f053";
          }
        }
        .owl-next {
          &:before {
            content: "\f054";
          }
        }
      }
    }
  }
  .property-text {
    p {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
